export default function render() {

  return `
    <div class="nhs-c-card--housing nhs-c-card--utour nhs-mq-card--utour-medium">
        <picture class="nhs-c-image--height-1480 nhs-mq-image--width-2100-medium nhs-c-card-skeleton__item--animated">
        </picture>
        <div class="nhs-c-card__body nhs-u-flex--1-1-auto" data-qa="card_body">
          <div class="nhs-c-card__content nhs-c-card__content--utour nhs-o-flex-column-self-stretch">
              <div class="nhs-o-flex-column-self-stretch nhs-u-gap--100">
                  <p class="nhs-c-card__plan-name nhs_SpecPlanName nhs-c-card-skeleton__item--animated">
                      &nbsp;
                  </p>
                  <p class="nhs-c-card__price nhs-c-card-skeleton__item--animated" data-card-element="price">
                      &nbsp;
                  </p>
              </div>
              <p class="nhs-c-card__facts nhs-u-width--full nhs-c-card-skeleton__item--animated" data-qa="card_specs">
                &nbsp;
              </p>
              <h3 class="nhs-c-card__facts nhs-u-width--full nhs-c-card-skeleton__item--animated">
                &nbsp;
              </h3>
          </div>
        </div>
    </div>
  `;
}